/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */
import { __assign } from "tslib";
import { Representation } from '../representation';
export var StructureRepresentationStateBuilder = {
    create: function () {
        return __assign(__assign({}, Representation.createState()), { unitTransforms: null, unitTransformsVersion: -1 });
    },
    update: function (state, update) {
        Representation.updateState(state, update);
        if (update.unitTransforms !== undefined)
            state.unitTransforms = update.unitTransforms;
    }
};
export function StructureRepresentationProvider(p) { return p; }
//
export { ComplexRepresentation } from './complex-representation';
export { ComplexVisual } from './complex-visual';
export { UnitsRepresentation } from './units-representation';
export { UnitsVisual } from './units-visual';
//# sourceMappingURL=representation.js.map